import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AdminProvider } from './context/AdminContext';
import { DealerProvider } from './context/DealerContext';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import AdminToolbar from './components/AdminToolbar';
import AdminLoginModal from './components/AdminLoginModal';
import ContentPanel from './components/ContentPanel';
import ScrollToTop from './components/ScrollToTop';
import ExhibitionModal from './components/ExhibitionModal';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CatalogPage from './pages/CatalogPage';
import InstallationPage from './pages/InstallationPage';
import VideoPage from './pages/VideoPage';
import CertificatesPage from './pages/CertificatesPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PublicOfferPage from './pages/PublicOfferPage';
import AGSK3Page from './pages/AGSK3Page';
import DealerLoginPage from './pages/DealerLoginPage';
import DealerDashboardPage from './pages/DealerDashboardPage';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isDealerRoute = location.pathname.startsWith('/dealer');

  return (
    <div className="App">
      {!isDealerRoute && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:productId" element={<ProductDetailPage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/installation" element={<InstallationPage />} />
        <Route path="/video" element={<VideoPage />} />
        <Route path="/certificates" element={<CertificatesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/agsk3" element={<AGSK3Page />} />
        <Route path="/dealer/login" element={<DealerLoginPage />} />
        <Route path="/dealer" element={<DealerDashboardPage />} />
      </Routes>
      {!isDealerRoute && <WhatsAppButton />}
      {!isDealerRoute && <Footer />}
      {!isDealerRoute && <AdminLoginModal />}
      {!isDealerRoute && <ContentPanel />}
      {!isDealerRoute && <ExhibitionModal />}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AdminProvider>
        <DealerProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppContent />
          </BrowserRouter>
        </DealerProvider>
      </AdminProvider>
    </LanguageProvider>
  );
}

export default App;
